module.exports = __webpack_public_path__ + "img/l200_drive.32f65255.jpg";